import { useDraw, useLabels, useMapCore, useMapStore } from "../hooks";
import { Menu } from "../primitives/Menu";

export type MeasureButtonProps = { className?: string };

export function MeasureButton({ className }: MeasureButtonProps) {
  const core = useMapCore();
  const labels = useLabels();
  const measure = useMapStore(a => a.measure);
  const { snapshot } = useDraw();
  const drawing = snapshot.geometry.mode !== null;

  return (
    <Menu
      label={labels.measure}
      icon="ruler"
      size="lg"
      placement="right-start"
      className={className}
      dataFxmap="measure-menu"
      triggerDataFxmap="measure"
      pressed={measure.mode !== null}
      disabled={drawing}
      items={[
        { id: "measure-distance", label: labels.measureDistance, icon: "ruler", checked: measure.mode === "distance", run: () => core.measure.start("distance") },
        { id: "measure-area", label: labels.measureArea, icon: "area", checked: measure.mode === "area", run: () => core.measure.start("area") },
        { id: "measure-clear", label: labels.measureClear, icon: "trash", separatorBefore: true, run: () => core.measure.clear() }
      ]}
    />
  );
}

export const MeasureMenu = MeasureButton;
